export default __webpack_public_path__ + "static/media/precios_LEED_feb_eng_V.1836b007.png";